import React, {useState} from 'react';
import './styles.scss';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import {colors} from '../../../../util/colors';
import {Icons} from '../../../../util/icons';
import {strings} from '../../../../util/strings';
import AppointmentListItem from '../appointment-list-item/AppointmentListItem';
import DoctorsListItem from '../doctors-list-item/DoctorsListItem';
import DoctorsListItemDayTime from '../doctors-list-item-day-time/DoctorsListItemDayTime';

export interface AppointmentsListProps {
  appointmentsItems: any;
  labels: typeof strings.pt.appointments;
  borderColor?: any;
  setRefresh(value: any): void;
  isDoctors?: boolean;
  isDoctorsDayTime?: boolean;
  nextStep?: Function;
  setSelectedAppointmentTime?(value: any): void;
  enableMedicInfo?: boolean;
}

function AppointmentsList({
  labels,
  appointmentsItems,
  borderColor,
  setRefresh,
  isDoctors,
  nextStep,
  isDoctorsDayTime,
  enableMedicInfo,
  setSelectedAppointmentTime,
}: AppointmentsListProps) {
  const [selectedTime, setSelectedTime]: any = useState({});

  const handleTimeChange = (value: any) => {
    setSelectedTime(value.key);
    if (setSelectedAppointmentTime) {
      setSelectedAppointmentTime(value.appointmentItem);
    }
  };

  return (
    /*if collection is empty, show message 'there are none'*/
    appointmentsItems?.length === 0 || !appointmentsItems?.length ? (
      <></>
    ) : (
      <>
        {!isDoctors &&
          !isDoctorsDayTime &&
          appointmentsItems?.map((element: any) => (
            <AppointmentListItem
              appointmentItem={element}
              borderColor={borderColor}
              setRefresh={setRefresh}></AppointmentListItem>
          ))}
        {isDoctors &&
          !isDoctorsDayTime &&
          appointmentsItems?.map((element: any) => (
            <DoctorsListItem
              nextStep={nextStep}
              appointmentItem={element}
              borderColor={borderColor}
              setRefresh={setRefresh}></DoctorsListItem>
          ))}
        {isDoctorsDayTime &&
          !isDoctors &&
          appointmentsItems?.map((element: any) => (
            <DoctorsListItemDayTime
              nextStep={nextStep}
              appointmentItem={element}
              borderColor={borderColor}
              setRefresh={setRefresh}
              setSelectedTime={(value: any) => handleTimeChange(value)}
              selectedTime={selectedTime}
              enableMedicInfo={
                enableMedicInfo ? enableMedicInfo : false
              }></DoctorsListItemDayTime>
          ))}
      </>
    )
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.refund,
});

export default compose(connect(mapStateToProps)(AppointmentsList));
